import Error from '@assets/icons/error.svg'
import { Icon } from './Icon'

export const ErrorIcon = Icon(Error)
